<template>
    <div class="userInfoBox" :style="getBoxBackgroundImage(RichLevelUserInfoData.current_level)">
        <div class="userImageBox">
            <!-- <img :src='RichLevelUserInfoData.profile_images?.[0]?.image_name || "defaultUserImage"' alt="" /> -->

            <img :src="userImageSrc" :alt="RichLevelUserInfoData.name || 'User avatar'" @error="onImgError" />
        </div>
        <div class="userNameBox">
            <div class="userNameTitle">{{ RichLevelUserInfoData.name }}</div>
            <div class="userLabelBox">
                <img :src="getLevelImage(RichLevelUserInfoData.current_level)" class="lavelImage" alt="level icon" />
                <span class="uaserLabelVal">{{ RichLevelUserInfoData.current_level }}</span>
            </div>
        </div>
        <div class="user-rechargeLavelBox">
            <!-- <div class="recharge-title">Recharge</div> -->
            <div class="flexBox itemCemter">
                <div class="diamond-iconBox"><img :src='diamondIcon' alt="" /></div>
                <div class="lavelVal">
                    {{
        typeof RichLevelUserInfoData.next_level_amount === 'number' && typeof
            RichLevelUserInfoData.redeem_point === 'number'
            ? (RichLevelUserInfoData.next_level_amount !== 0
                ? RichLevelUserInfoData.next_level_amount - RichLevelUserInfoData.redeem_point
                : RichLevelUserInfoData.next_level_amount)
            : 'Loading...'
    }}
                </div>
                <sub class="lavel-title">to level up</sub>
            </div>
            <div class="progressBarBox">
                <div class="progressBar-wrap">
                    <div class="pb-status" :style="{ width: progressPercentage + '%' }">
                        <!-- <div class="ourValue">{{ RichLevelUserInfoData.redeem_point }}</div> -->
                    </div>
                </div>
                <div class="flexBox justify-content-between align-items-center mt-2 pb-lavelWrap">
                    <div class="pb-currentLavel">Lv {{ RichLevelUserInfoData.current_level }}</div>
                    <div class="pb-nextLavel">Lv {{ RichLevelUserInfoData.next_level }}</div>
                </div>
            </div>
            <!-- <div class="progressBar-wrap">
                <div class="pb-currentLavel">Lv {{ RichLevelUserInfoData.current_level }}</div>
                <div class="pb-nextLavel">Lv {{ RichLevelUserInfoData.next_level }}</div>
                <div class="pb-status" :style="{ width: progressPercentage + '%' }">
                    <div class="ourValue">{{ RichLevelUserInfoData.redeem_point }}</div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import defaultUserImage from '../../assets/images/default_profile.webp'
import diamondIcon from '../../assets/images/diamond-icon.png'

export default {
    name: 'RichLavelUserInfoComponent',
    data() {
        return {
            imgErrored: false,
            RichLevelUserInfoData: [],
            defaultUserImage,
            diamondIcon,
            profile_images: []
        }
    },
    computed: {
        userImageSrc() {
            if (this.imgErrored) return this.defaultUserImage // ✅ now defined
            const apiImg = this.RichLevelUserInfoData?.profile_images?.[0]?.image_name
            return apiImg || this.defaultUserImage
        },
        progressPercentage() {
            const { redeem_point, next_level_amount, next_level } = this.RichLevelUserInfoData;
            if (next_level === 0) {
                return 100;
            }
            if (!redeem_point || !next_level_amount) return 0;
            return 100 - ((next_level_amount - redeem_point) * 100) / next_level_amount;
        },
    },
    watch: {
        '$route.params.profile_id': 'fetchRichLeveUserInfolData'
    },
    mounted() {
        this.fetchRichLeveUserInfolData();
    },
    methods: {
        onImgError(e) {
            this.imgErrored = true
            // stop infinite loops and swap to default
            e.target.onerror = null
            e.target.src = this.defaultUserImage
        },
        fetchRichLeveUserInfolData() {
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/user-rich-charm-level-details?type=rich_level`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.RichLevelUserInfoData = response.data.result.data;
                })

                .catch(error => {
                    console.error("Error Featching Rich Lavel Data", error)
                })
        },
        getLevelImage(rich_lavel) {
            switch (true) {
                case rich_lavel === 0:
                return require('@/assets/images/rich-lavel-0.png');
                case rich_lavel === 1:
                return require('@/assets/images/rich-lavel-1.png');
                case rich_lavel >= 2 && rich_lavel <= 10:
                return require('@/assets/images/rich-lavel-2.png');
                case rich_lavel >= 11 && rich_lavel <= 20:
                return require('@/assets/images/rich-lavel-3.png');
                case rich_lavel >= 21 && rich_lavel <= 30:
                return require('@/assets/images/rich-lavel-5-8.png');
                case rich_lavel >= 31 && rich_lavel <= 40:
                return require('@/assets/images/rich-lavel-12.png');
                case rich_lavel >= 41 && rich_lavel <= 50:
                return require('@/assets/images/rich-lavel-15.png');
                // case rich_lavel === 0:
                //     return require('@/assets/images/rich-lavel-0.png');
                // case rich_lavel === 1:
                //     return require('@/assets/images/rich-lavel-1.png');
                // case rich_lavel === 2:
                //     return require('@/assets/images/rich-lavel-2.png');
                // case rich_lavel === 3:
                //     return require('@/assets/images/rich-lavel-3.png');
                // case rich_lavel === 4:
                //     return require('@/assets/images/rich-lavel-4.png');
                // case rich_lavel >= 5 && rich_lavel <= 8:
                //     return require('@/assets/images/rich-lavel-5-8.png');
                // case rich_lavel >= 9 && rich_lavel <= 11:
                //     return require('@/assets/images/rich-lavel-9-11.png');
                // case rich_lavel === 12:
                //     return require('@/assets/images/rich-lavel-12.png');
                // case rich_lavel === 13:
                //     return require('@/assets/images/rich-lavel-13.png');
                // case rich_lavel === 14:
                //     return require('@/assets/images/rich-lavel-14.png');
                // case rich_lavel === 15:
                //     return require('@/assets/images/rich-lavel-15.png');
                default:
                    return require('@/assets/images/rich-lavel-0.png');
            }
        },
        getBoxBackgroundImage(rich_lavelBG) {
            switch (true) {
                case rich_lavelBG === 0:
                    return { backgroundImage: `url(${require('@/assets/images/richBoxBg-lavel-0.png')})` };
                case rich_lavelBG === 1:
                    return { backgroundImage: `url(${require('@/assets/images/richBoxBg-lavel-1.png')})` };
                case rich_lavelBG === 2:
                    return { backgroundImage: `url(${require('@/assets/images/richBoxBg-lavel-2.png')})` };
                case rich_lavelBG >= 3 && rich_lavelBG <= 5:
                    return { backgroundImage: `url(${require('@/assets/images/richBoxBg-lavel-3-5.png')})` };
                case rich_lavelBG >= 6 && rich_lavelBG <= 10:
                    return { backgroundImage: `url(${require('@/assets/images/richBoxBg-lavel-6-10.png')})` };
                case rich_lavelBG >= 11 && rich_lavelBG <= 15:
                    return { backgroundImage: `url(${require('@/assets/images/richBoxBg-lavel-11-15.png')})` };
                default:
                    return { backgroundImage: `url(${require('@/assets/images/richBoxBg-lavel-0.png')})` };
            }
        }

    },
}
</script>